var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38867 15.4338C4.137 15.5343 3.89818 15.5129 3.67221 15.3696C3.44624 15.2263 3.33325 15.0175 3.33325 14.7433V11.2256L9.10242 9.83147L3.33325 8.43731V4.9196C3.33325 4.64543 3.44624 4.43668 3.67221 4.29335C3.89818 4.15001 4.137 4.12863 4.38867 4.22918L16.0191 9.13272C16.3289 9.27147 16.4839 9.50488 16.4839 9.83293C16.4839 10.161 16.3289 10.3934 16.0191 10.5302L4.38867 15.4338Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageIcon);
export default __webpack_public_path__ + "static/media/SendMessageIcon.b586249b73711a0cbbdcc5b86992982f.svg";
export { ForwardRef as ReactComponent };